import Vue from 'vue';
import axios from 'axios';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import '@babel/polyfill';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';
import './transitions.css';
import configs from './common/configs.js';
import { DateTime, Duration } from 'luxon';
import VueSocketIOExt from 'vue-socket.io-extended';
import { io } from 'socket.io-client';

Vue.config.productionTip = false;

axios.defaults.baseURL = configs.apiUrl;
axios.defaults.headers.common['Content-Type'] = 'application/json';

Vue.filter('formatDay', function(value) {
	if (value) {
		return DateTime.fromISO(String(value)).toFormat('dd.MM.yy');
	}
});

Vue.filter('formatSeconds', function(seconds) {
	if (seconds) {
		return Duration.fromMillis(seconds * 1000).toFormat('HH:mm');
	}
});
Vue.filter('formatDayTime', function(value) {
	if (value) {
		return DateTime.fromISO(String(value)).toFormat('dd.MM.yy HH:mm:ss');
	}
});

const socket = io(configs.apiUrl);
Vue.use(VueSocketIOExt, socket, { store });

new Vue({
	router,
	store,
	vuetify,
	render: (h) => h(App),
	sockets: {
		connect() {
			console.log('socket connected');
		},
		customEmit(val) {
			console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)');
		},
	},
}).$mount('#app');
